<script setup lang="ts">
import YscButtonSubmit from './YscButtonSubmit.vue'
import YscInputKeyboard from './YscInputKeyboard.vue'
import { ref } from '#imports'

interface Props {
  loading?: boolean
}

withDefaults(defineProps<Props>(), {
  loading: false,
})

const emits = defineEmits<{
  submit: [{ email: string }]
}>()

const form = ref<{ email: string | null }>({
  email: null,
})

const onSubmit = () => {
  const isValidForm = (f: { email: string | null }): f is { email: string } => {
    return !!form.value.email
  }
  if (isValidForm(form.value)) {
    emits('submit', form.value)
  }
}
</script>

<template>
  <form
    class="flex flex-wrap items-start gap-4"
    @submit.prevent.stop="onSubmit"
  >
    <YscInputKeyboard
      id="newsletter-email"
      v-model="form.email"
      required
      type="email"
      :placeholder="$t('data.user.email.placeholder')"
      class="w-64 max-w-full shrink"
    >
      <!-- :size="25" -->
      <template
        v-if="$slots.description"
        #description
      >
        <slot name="description" />
      </template>
      <template
        v-if="$slots.error"
        #error
      >
        <slot name="error" />
      </template>
    </YscInputKeyboard>
    <YscButtonSubmit
      class="w-fit shrink-0 !text-sm"
      :loading="loading"
    >
      {{ $t('commons.register') }}
    </YscButtonSubmit>
  </form>
</template>
